import React from "react";

type PanelWithHeaderProps = {
  children: any;
  header: string;
  iconClassName?: string;
  showAddIcon?: boolean;
  handleAddAction?: any;
};

export const PanelWithHeader = (props: PanelWithHeaderProps) => {
  return (
    <div className="card">
      <div className="card-header">
        <div style={{ display: "inline-flex", width: "100%" }}>
          {props.iconClassName && (
            <div>
              <i
                style={{ marginRight: "10px" }}
                className={props.iconClassName}
              ></i>
            </div>
          )}
          <div style={{ width: "100%" }}>{props.header}</div>
          {props.showAddIcon && (
            <div>
              <i
                onClick={props.handleAddAction}
                style={{ marginRight: "10px" }}
                className="far fa-plus-square"
              ></i>
            </div>
          )}
        </div>
      </div>
      <div className="card-body">{props.children}</div>
    </div>
  );
};
